import {Button, Sheet, Stack} from "@mui/joy";
import Grid from "@mui/material/Grid";
import {Pagination} from "@mui/material";
import {WasteFlavorStub} from "../rpc/webrpc-client.gen.ts";
import React, {useEffect, useMemo, useState} from "react";
import {HCBox} from "../components/HCBox.tsx";
import {SearchFilter} from "../forms.tsx";
import {InfallibleUseResult} from "../util/hookutil.tsx";
import {NADA} from "../util/arutil.tsx";

const WASTE_FLAVOR_PAGE_SIZE = 24;

export interface WasteFlavorChooserProps {
    flavors: InfallibleUseResult<WasteFlavorStub[]>;
    onChosen: (chosen: WasteFlavorStub | null) => void;
    currentSelection?: WasteFlavorStub;
}

const PAGE_SIZE = 24;

export function WasteFlavorChooser(props: WasteFlavorChooserProps) {
    const {
        flavors: {data: showableFlavorsData},
        currentSelection,
        onChosen,
    } = props;
    const [filterSnippet, setFilterSnippet]
        = useState<string>("");
    const showableFlavors = showableFlavorsData ?? NADA;
    const filteredFlavors = useMemo(() => {
        if (filterSnippet !== "") {
            return showableFlavors.filter(maybe =>
                maybe.displayName.includes(filterSnippet));
        } else {
            return showableFlavors;
        }
    }, [filterSnippet, showableFlavors]);
    const lastPageNum = Math.trunc((filteredFlavors.length - 1) / WASTE_FLAVOR_PAGE_SIZE);
    const [pageNum, setPageNum]
        = useState<number>(1);
    const handlePageNumChange = (_: React.ChangeEvent<unknown>, value: number) => {
        setPageNum(value);
    };
    const [pageFlavors, setPageFlavors]
        = useState<WasteFlavorStub[]>(filteredFlavors.slice((pageNum - 1) * PAGE_SIZE,
        pageNum * PAGE_SIZE))
    useEffect(() => {
        setPageFlavors(filteredFlavors.slice((pageNum - 1) * PAGE_SIZE,
            pageNum * PAGE_SIZE));
    }, [filteredFlavors, pageNum]);

    return <Sheet variant="outlined"
                  sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                  }}>
        <Stack direction="column" spacing={1}>
            <SearchFilter
                onSet={snippet => {
                    setFilterSnippet(snippet);
                    setPageNum(1);
                }}
                onReset={() => {
                    setFilterSnippet("");
                    setPageNum(1);
                }}/>
            {lastPageNum > 1
                ? <HCBox><Pagination
                    count={lastPageNum}
                    page={pageNum}
                    onChange={handlePageNumChange}
                ></Pagination></HCBox>
                : null}
            <Grid container sx={{flexGrow: 1}}>
                {pageFlavors.map(flavor =>
                    <Grid size={{xs: 6, md: 4}} key={flavor.id} sx={{
                        display: "flex",
                        justifyContent: "center",
                    }}>
                        <Button
                            size="lg"
                            color="primary"
                            sx={{
                                px: "0.8rem",
                                py: "1rem"
                            }}
                            variant={flavor.id === currentSelection?.id ? "solid" : "plain"}
                            onClick={() => {
                                onChosen(flavor);
                            }}>
                            {flavor.displayName}
                        </Button>
                    </Grid>
                )}
            </Grid>
        </Stack>
    </Sheet>
}
